import { Button, Dialog, DialogContent, DialogTitle, IconButton, DialogActions, TextField, Grid } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from "react";
import { getCompanyId, getToken, getUser } from "../../Utils/Common";
import AlertSnackbar from '../../components/AlertSnackbar/AlertSnackbar';
import axios from "axios";


const UserProfileDialog = ({ open, handleClose, onClose }) => {

    const [userInfo, setUserInfo] = useState({});


    useEffect(() => {
        getUserData();
    }, [])

    const companyId = sessionStorage.getItem("companyId")
    const userId = sessionStorage.getItem("userId")

    const getUserData = async () => {
        const url = `/api/companies/${companyId}/users/${userId}`
        axios({
            method: "get",
            url: url,
            params: { withAuth: false },
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        }).then((data) => {
            setUserInfo(data?.data?.userProfile)
        }).catch((error) => {
            console.log('error in get user data api call:', error);

            let message = `Failed to get data [${companyId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

            setNotify({
                isOpen: true,
                alertTitle: 'Request failed',
                message: message,
                severity: 'error'
            });
        })
    }

    const updateUserData = () => {
        const url = `/api/companies/${companyId}/users/${userId}`
        axios({
            method: "put",
            url: url,
            data: { firstName: userInfo?.firstName, lastName: userInfo?.lastName },
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        }).then((data) => {
            handleClose()

            let message = `Profile updated successfully.`;

            setNotify({
                isOpen: true,
                alertTitle: 'Success',
                message: message,
                severity: 'success'
            });



        }).catch((error) => {
            console.log('error in update profile api call:', error);

            let message = `Failed to get data [${companyId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

            setNotify({
                isOpen: true,
                alertTitle: 'Request failed',
                message: message,
                severity: 'error'
            });
        })
    }


    const initialSnackbarState = {
        open: false,
        message: '',
        alertTitle: '',
        severity: 'info',
        hideDuration: 1000
    };

    const [notify, setNotify] = useState(
        initialSnackbarState
    );


    const handleChange = (e, field) => {
        setUserInfo({ ...userInfo, [field]: e?.target?.value })
    }

    return (
        <>
            <AlertSnackbar
                notify={notify}
                setNotify={setNotify} />

            <Dialog onClose={handleClose} open={open} maxWidth={'sm'} fullWidth={true}>
                <DialogTitle>
                    <div className="userPermissionDialogTitle">User Profile</div>
                    {onClose ? (
                        <IconButton
                            aria-label="close"
                            onClick={onClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    ) : null}
                </DialogTitle>
                <DialogContent dividers={true}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField id="outlined-basic" label="Company Id" variant="outlined" value={companyId} fullWidth disabled />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField id="outlined-basic" label="User Id" variant="outlined" value={userId} fullWidth disabled />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField required id="outlined-basic" label="First Name" variant="outlined" onChange={(e) => handleChange(e, 'firstName')} value={userInfo.firstName} fullWidth />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField required id="outlined-basic" label="Last Name" variant="outlined" onChange={(e) => handleChange(e, 'lastName')} value={userInfo.lastName} fullWidth />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button variant="text" size="small" sx={{ textTransform: 'none' }} onClick={handleClose}>Cancel</Button>
                    <Button
                        variant="contained"
                        size="small"
                        sx={{
                            color: '#333330',
                            backgroundColor: '#82C027',
                            boxShadow: '0px 1px 2px #6F7687',
                            borderRadius: '5px',
                            textTransform: 'none',
                            '&:hover': {
                                backgroundColor: '#82C027',
                                boxShadow: 'none'
                            }
                        }}
                        onClick={updateUserData}>Save</Button>
                </DialogActions>
            </Dialog >
        </>

    );
};

export default UserProfileDialog;
